import ListingVM from './listing-vm.vue';
import Vue from 'vue';
import 'libs/vue-extensions';

export default {
  init: function(ele) {
    console.log('StudentCourseLearningModule initialization function called');
    const listingVM = new Vue(ListingVM);
    listingVM.$mount(ele);
  }
};

